import React, { useCallback, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { IntlContext } from '@jutro/locale';
import { ModalNextProvider, IconButton } from '@jutro/components';
import { withApplicationPropertyContext } from 'tdic-components-platform-react';
import { messages as commonMessages } from 'gw-platform-translations';
import metadata from './BillingDocuments.metadata.json5';
import styles from './BillingDocuments.module.scss';
import messages from './BillingDocuments.messages';

const getCell = (item, index, property) => {
    return item[property.id];
};

function BillingDocuments({
    data: billingDocument
}) {
    const intl = useContext(IntlContext);
    const { BillingService: DocumentBillingService } = useDependencies('BillingService');

    const getDocumentDate = useCallback((item, index, property) => {
        return `${intl.formatDate(new Date(item[property.id]), {
            year: 'numeric', month: 'short', day: 'numeric'
        })} ${intl.formatTime(new Date(item[property.id]), {
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        })}`;
    }, []);

    const onViewDownloadClicked = useCallback((document) => {
        const { publicID, sessionID } = document;
        DocumentBillingService.getBillingDocumentLink(publicID, sessionID)
            .then((response) => {
                if (response.ok) {
                    response.text().then((text) => {
                        const docWin = window.open('', '_blank');
                        docWin.document.write(text);
                    });
                } else {
                    ModalNextProvider.showAlert({
                        title: messages.viewDownload,
                        message: messages.downloadErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).then(_.noop);
                }
            });
    }, [DocumentBillingService]);

    const getViewDownloadCell = useCallback((item) => {
        if (_.get(item, 'docUID', 'none') !== 'none') {
            return (
                <IconButton icon="mi-insert_drive_file" onClick={() => onViewDownloadClicked(item)} />
            );
        }
        return null;
    }, [onViewDownloadClicked]);

    const overrideProps = {
        documentsTableGrid: {
            data: _.sortBy(billingDocument, 'dateModified').reverse()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell,
            getViewDownloadCell,
            getDocumentDate
        }
    };
    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

BillingDocuments.propTypes = {
    data: PropTypes.shape([]).isRequired
};

BillingDocuments.defaultProps = {

};

export default
withRouter(withAuthenticationContext(withApplicationPropertyContext(BillingDocuments)));
